module.exports = __webpack_public_path__ + "static/media/ic_invest_build_wealth.f7d08a6e.svg";